import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import WorkflowNodeStatusDomainService from "../../../Domain/WorkflowNodeStatus/WorkflowNodeStatus.service";
const WorkflowNodeStatusBadge = ({ workflowNodeStatusId, statusMap, }) => {
    var _a, _b;
    const name = (_b = (statusMap
        ? statusMap[workflowNodeStatusId]
        : (_a = WorkflowNodeStatusDomainService.getFromId(workflowNodeStatusId)) === null || _a === void 0 ? void 0 : _a.name)) !== null && _b !== void 0 ? _b : "Unknown";
    return (_jsx("span", { className: `badge badge-${WorkflowNodeStatusDomainService.getBootstrapColor(workflowNodeStatusId)}`, title: name, children: name }));
};
export default WorkflowNodeStatusBadge;
